const TOAST_TYPE = {
  INFO: 0,
  SUCCESS: 1,
  ERROR: 2,
  WARNING: 3,
};

class ToastManager {
  constructor() {
    this.toaster = null;
  }
  register(toaster) {
    this.toaster = toaster;
  }
  errorToast(msg) {
    if (this.toaster) this.toaster(TOAST_TYPE.ERROR, msg);
  }
  infoToast(msg) {
    if (this.toaster) this.toaster(TOAST_TYPE.INFO, msg);
  }
  warningToast(msg) {
    if (this.toaster) this.toaster(TOAST_TYPE.WARNING, msg);
  }
  successToast(msg) {
    if (this.toaster) this.toaster(TOAST_TYPE.SUCCESS, msg);
  }
}

const instance = new ToastManager();

export default instance;
